import { Injectable } from '@angular/core';
import { DownloadItem } from '@app/shared/types/downloads-block.types';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  // This function is used to push the logged-in event to the dataLayer
  // for Google Tag Manager (GTM) tracking.
  // It is called when the user successfully logs in.
  dataLayer_Login(): void {
    (window as any).dataLayer.push({
      event: 'login_success',
    });
  }

  dataLayer_Download(item: DownloadItem): void {
    (window as any).dataLayer.push({
      event: 'download_click',
      download: {
        name: item,
      },
    });
  }

  // This function will be used to push the signup event to the dataLayer
  // dataLayer_Signup(): void {
  //   (window as any).dataLayer.push({
  //     event: 'signup_success',
  //   });
  // }
}
